<template>
  <card>
    <div class="container">
      <div class="row">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">請輸入桌號</label>
            <div class="col-sm-8">
              <fg-input placeholder="桌號" v-model="tableNumber"></fg-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-4 col-form-label">圖片大小(pixel)</label>
            <div class="col-sm-8">
              <fg-input placeholder="size" v-model="size"></fg-input>
            </div>
          </div>
        </div>

        <div class="col-sm-2">
          <n-button type="primary" round @click.native="appendQRCode">產生QR code</n-button>
        </div>
        <div class="col-sm-2">
          <n-button native-type="button" type="gray" @click.native="home()">回商店列表</n-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <card>
            <div class="table-shopping">
              <el-table style="width: 100%" :data="qrData">
                <el-table-column min-width="220">
                  <div slot-scope="{row}">
                    <qrcode-vue :value="row.link" :size="size" level="H" download></qrcode-vue>
                    <a :id="'_' + row.tableNumber" :download="row.tableNumber + '.png'">
                    </a>
                  </div>
                </el-table-column>
                <el-table-column min-width="180" label="桌號" prop="tableNumber"></el-table-column>
                <el-table-column min-width="180" label="網址">
                  <div slot-scope="{row}">
                    {{row.link}}
                    <br>
                      <input type="hidden" :id="row.tableNumber+'-link'" :value="row.link" style="">
                  </div>
                </el-table-column>
                <el-table-column min-width="80" label="#">
                  <template slot-scope="{row}">
                    <button @click="del(row.id)">刪除</button>
                    <button type="button" @click="download(row.tableNumber)">下載</button>
                    <button type="button" @click="copy(row)">複製連結</button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </card>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { Pagination } from "src/components";
import { Table, TableColumn } from "element-ui";
import swal from "sweetalert2";
import moment from "moment-timezone";
import { fetchQrcode } from "./fetchData";
import { insertQrcode, toShortUrl } from "./postData";
import { deleteQrcode } from "./deleteData";
import { Modal } from 'src/components';

var type;
export default {
  beforeRouteEnter(to, from, next) {
    let id = to.params.id;
    type = to.params.type;
    fetchQrcode(id, type)
      .then(res => {
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      qrData: [],
      accountId: "",
      size: 200,
      tableNumber: "",
      value: "",
      shopId: ""
    };
  },
  components: {
    QrcodeVue,
    [Pagination.name]: Pagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal
  },
  methods: {
    setData(data) {
      this.qrData = data.qrcode;
      this.shopId = data.shopId;
    },
    appendQRCode: function() {
      if (this.duplicate()) {
        swal("桌號重複");
      } else if(!this.isExist()) {
        swal("桌號不能空白");
      } else {
        let data = {
          shopId: this.shopId,
          tableNumber: this.tableNumber
        };
        insertQrcode(data, type)
          .then(res => {
            // let qrData = {
            //   endpoint: res.data.results.endpoint,
            //   accountId: res.data.results.accountId,
            //   // token: res.data.results.token,
            //   tableNumber: this.tableNumber
            // };
            let obj = Object.assign(
              {},
              {
                tableNumber: this.tableNumber,
                id: res.data.results.insertQrcodeRes.insertId,
                endpoint: res.data.results.endpoint,
                accountId: res.data.results.accountId,
                link: res.data.results.link
                // token: res.data.results.token
              }
            );
            this.$set(this.qrData, this.qrData.length, obj);
            this.tableNumber = "";
          })
          .catch(err => {
            console.log("err: ", err);
          });
      }
    },
    duplicate() {
      return this.qrData.some(d => d.tableNumber === this.tableNumber);
    },
    isExist() {
      return this.tableNumber ? true : false;
    },
    createLink(row) {
      let endpoint = row.endpoint;
      let accountId = row.accountId;
      let tableNumber = row.tableNumber;
      let token = row.token;
      let link = encodeURI(
        `${endpoint}?accountId=${accountId}&tableNum=${tableNumber}&token=${token}&source=qrcode`
      );
      return link;
    },
    download(tableNumber) {
      let a = this.$el.querySelector("#_" + tableNumber);
      let parentNode = a.parentNode;
      let canvas = parentNode.getElementsByTagName("canvas")[0];
      let img = canvas.toDataURL("image/png");
      a.setAttribute("href", img);
      a.click();
    },
    copy(row) {
      let textToCopy = document.querySelector(`#${row.tableNumber}-link`);
      textToCopy.setAttribute('type', 'text');
      textToCopy.select();
      var successful = document.execCommand("copy");
      if(successful){
        swal(`內用連結${row.tableNumber}已複製`)
      }
      textToCopy.setAttribute('type', 'hidden');

    },
    home: function() {
      window.history.back();
    },
    del(qrcodeId) {
      deleteQrcode(qrcodeId, type)
        .then(res => {
          let index = this.qrData.findIndex(element => {
            return element.id === qrcodeId;
          });
          this.qrData.splice(index, 1);
        })
        .catch(err => {
          console.log("err: ", err);
        });
    }
  }
};
</script>
